export const jpJoinUsersFinished = {
  SB22title: '参加登録完了',
  SB22title2: '参加登録完了',
  SB22Top: 'トップへ',
  SB22description: 'コミュニティへの参加登録が完了しました。',
  SB22description3: 'ログイン後、トップ画面よりコミュニティへ入室してください。',
  SB22description2: 'コミュニティへの参加登録が完了しました。',
  SB22description4: 'ログイン後、トップ画面よりコミュニティへ入室してください。',
}
